import React from 'react';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import {
  aiAlertMetricSelector,
  includesAiAlertEventWindowSelector,
} from '@store/trends/aiAlerts/selectors';
import { IconWrapper, DiagWrapper } from '../styled';
import { CHART_TYPE } from '@components/metrics-panel-hz/hooks/utils';
import LegendIcon from '@icons/common/legend.svg';
import { HIDE_PEAK_VALUE_METRICS } from '@src/components/ai-alerts/constants';
import { getAlertMetricInfo } from '@src/store/trends/tempDashboard/aiAlertDiagnostics/sagas';

function LegendToggle({ metric, onToggle, chartMode }) {
  const includesAlertWindow = useSelector(includesAiAlertEventWindowSelector);
  const alertMetric = useSelector(aiAlertMetricSelector);
  const diagnosticsMetric = getAlertMetricInfo(alertMetric);
  const showLegend =
    includesAlertWindow &&
    metric === diagnosticsMetric &&
    chartMode === CHART_TYPE.LINE &&
    !HIDE_PEAK_VALUE_METRICS.includes(alertMetric);

  const handleClick = () => {
    onToggle();
  };

  return showLegend ? (
    <Tooltip title="Legend">
      <DiagWrapper>
        <IconWrapper onClick={handleClick}>
          <LegendIcon />
        </IconWrapper>
      </DiagWrapper>
    </Tooltip>
  ) : null;
}

export default LegendToggle;
